module.exports = __webpack_public_path__ + "img/home-01.98e8794b.png";